import { gql } from '@apollo/client';
import { Products } from '../../fragments/product/products.fragments';

const QUERY_PRODUCTS = gql`
  query getProducts {
    produits(sort: "ref:ASC") {
      data {
        id
        attributes {
          ...MainProducts
        }
      }
    }
  }
  ${Products.fragments.main}
`;
export default QUERY_PRODUCTS;
